document.addEventListener("DOMContentLoaded", () => {
  const headingWrapper = document.querySelector(".footer__blocks-wrapper");
  if (headingWrapper && window.innerWidth < 1000) {
    headingWrapper.addEventListener("click", (e) => {
      const target = e.target.closest(".footer-block__heading");
      if (target !== null) {
        e.target.classList.toggle("open");
      }
    });
  }
});
